/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTranscriptionRequest } from '../models/CreateTranscriptionRequest';
import type { CreateTranscriptionResponse } from '../models/CreateTranscriptionResponse';
import type { DeleteTranscriptionResponse } from '../models/DeleteTranscriptionResponse';
import type { DownloadUrlResponse } from '../models/DownloadUrlResponse';
import type { Transcription } from '../models/Transcription';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TranscriptionsService {

    /**
     * Creates a new transcription.
     * @param requestBody The request to create a transcription.
     * @returns CreateTranscriptionResponse OK
     * @throws ApiError
     */
    public static createTranscription(
        requestBody?: CreateTranscriptionRequest,
    ): CancelablePromise<CreateTranscriptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/transcriptions/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a transcription by its ID, including associated files in storage.
     * @param organizationId
     * @param transcriptionId
     * @returns DeleteTranscriptionResponse OK
     * @throws ApiError
     */
    public static deleteTranscription(
        organizationId: string,
        transcriptionId: string,
    ): CancelablePromise<DeleteTranscriptionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/transcriptions/{organizationId}/delete/{transcriptionId}',
            path: {
                'organizationId': organizationId,
                'transcriptionId': transcriptionId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Downloads transcription data in JSON format by providing a pre-signed URL.
     * @param organizationId
     * @param transcriptionId
     * @returns DownloadUrlResponse OK
     * @throws ApiError
     */
    public static downloadTranscriptionJson(
        organizationId: string,
        transcriptionId: string,
    ): CancelablePromise<DownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transcriptions/{organizationId}/download/json/{transcriptionId}',
            path: {
                'organizationId': organizationId,
                'transcriptionId': transcriptionId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Downloads transcription data in CSV format by providing a pre-signed URL.
     * @param organizationId
     * @param transcriptionId
     * @returns DownloadUrlResponse OK
     * @throws ApiError
     */
    public static downloadTranscriptionCsv(
        organizationId: string,
        transcriptionId: string,
    ): CancelablePromise<DownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transcriptions/{organizationId}/download/csv/{transcriptionId}',
            path: {
                'organizationId': organizationId,
                'transcriptionId': transcriptionId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all projects for the specified workspace, excluding those created via the external API.
     * @param organizationId The ID of the organization to scope the transcriptions for.
     * @returns Transcription OK
     * @throws ApiError
     */
    public static getTranscriptions(
        organizationId: string,
    ): CancelablePromise<Array<Transcription>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transcriptions/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
